import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { locationRanges, locations } from './slices/locations';
import { pinboards } from './slices/pinboards';
const rootReducer = combineReducers({
    locations: locations.reducer,
    locationRanges: locationRanges.reducer,
    pinboards: pinboards.reducer,
});
const store = configureStore({
    reducer: rootReducer,
});
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
export default store;
